import { render, staticRenderFns } from "./PurchaseOrderReceivedItems.vue?vue&type=template&id=24370c14&scoped=true&"
import script from "./PurchaseOrderReceivedItems.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOrderReceivedItems.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseOrderReceivedItems.vue?vue&type=style&index=0&id=24370c14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24370c14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VMenu,VSelect,VTextField})
